<template>
  <div class="logistics-info-box">
    <div class="nav-bar">
      <view class="navItem" v-for="item in logisticsTitle" :key="item.id" @click="selectFunction(item.id)" :class="{ choseItem: logisticsId == item.id }">
        {{ item.text }}
      </view>
    </div>
    <div class="logistics-list">
      <router-link
        :to="{
          name: 'LogisticParticulars',
          query: { companyId: item.companyId, id: item.serialNumber },
        }"
        class="logistics-item"
        v-for="item in shipments"
        :key="item.serialNumber"
      >
        <view class="logistics-top">
          <view>始</view>
          <view>{{ item.startProvince }}</view>
          <img src="@/assets/Bluearrow.png" />
          <view>终</view>
          <view>{{ item.endProvince }}{{ item.endCity }}</view>
        </view>
        <view class="middle">
          <view class="middleTop">
            重货
            <view>{{ item.heavyGoodsPrice }}元</view>
            <del>
              {{ item.heavyGoodsPrice }}
            </del>
            / kg
          </view>
        </view>
        <view class="middle">
          <view class="middleTop">
            轻货
            <view>{{ item.lightGoodsPrice }}元</view>
            <del>
              {{ item.lightGoodsPrice }}
            </del>
            / m³
          </view>
        </view>
        <view class="bottom">
          <div class="bottom-left">
            物流商：
            <span class="carrier-text">{{ item.carrier }}</span>
            <img src="@/assets/arrow.png" />
          </div>
          <div class="bottom-right">
            <view>包接</view>
            <view>包送</view>
          </div>
        </view>
      </router-link>
    </div>
  </div>
</template>
<script>
  import { getTransportPriceCustomQagingQuery } from '@/apis/modules/logistics/index.js';
  import { ElMessage } from 'element-plus';
  import { ref } from 'vue';
  const currentTab = ref(1); // 默认1为LogisticsInfo

  export default {
    data() {
      return {
        shipments: [],
        logisticsTitle: [
          { id: 1, text: '国内物流' },
          { id: 2, text: '国际物流' },
          { id: 6, text: '工厂企业' },
          { id: 3, text: '实时车源' },
          { id: 4, text: '实时货源' },
          // { id: 5, text: '物流园区' }
        ],
        logisticsId: 1,
        asd: '物流信息',
      };
    },
    mounted() {
      this.fetchShipments();
    },
    methods: {
      async fetchShipments() {
        // 获取物流信息列表并格式化数据
        try {
          const res = await getTransportPriceCustomQagingQuery({ pageNo: 1, pageSize: 6, companyType: 1 });
          if (res && res.statusCode === 20000 && res.data && Array.isArray(res.data)) {
            this.shipments = res.data.map(item => ({
              serialNumber: item.id,
              startProvince: item.startAddress,
              endProvince: item.addressCity,
              endCity: item.addressArea,
              heavyGoodsPrice: item.weight,
              lightGoodsPrice: item.volume,
              carrier: item.companyName,
              companyId: item.companyId,
            }));
          }
        } catch (e) {}
      },
      selectFunction(id) {
        // 切换顶部物流类型并通知父组件
        if (id === 2 || id === 3) {
          ElMessage({ message: '该功能未开放，敬请期待！', type: 'warning' });
          return;
        }
        this.logisticsId = id;
        this.$emit('selectLogistics', id);
        // console.log(this.logisticsId);
      },
      handleSelectLogistics(id) {
        currentTab.value = id;
      },
    },
  };
</script>

<style scoped lang="scss">
  .logistics-info-box {
    width: 924px;
    height: 880px;
    background: white;
    box-sizing: border-box;
    padding: 8px 24px 0px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .nav-bar {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 24px;
      border-width: 0px 0px 1px 0px;
      border-style: solid;
      border-color: rgba(0, 27, 81, 0.4);
      box-sizing: border-box;
      margin-bottom: 24px;
      .navItem {
        display: flex;
        align-items: center;
        height: 64px;
        margin-right: 80px;
        padding-bottom: 4px;
        color: rgba(0, 27, 81, 0.4);
        border-bottom: 4px solid rgba(0, 0, 0, 0);
        cursor: pointer;
        font-family: PingFang SC;
        font-size: 20px;
        font-weight: 500;
        line-height: 30px;
        letter-spacing: normal;
        color: rgba(0, 27, 81, 0.4);
      }
      .choseItem {
        border-bottom: 6px solid #001b51;
        color: #001b51;
        font-weight: bold;
      }
    }
    .logistics-list {
      display: grid;
      gap: 24px;
      grid-template-columns: repeat(2, 1fr);
      .logistics-item {
        width: 426px;
        height: 228px;
        background: linear-gradient(180deg, #f1f7ff 0%, #f1f7ff 100%);
        box-sizing: border-box;
        padding-top: 25px;
        padding-left: 25px;
        cursor: pointer;
        text-decoration: none;
        .logistics-top {
          display: flex;
          align-items: center;
          margin-bottom: 25px;
          img {
            width: 30px;
            height: 10px;
          }
          view {
            font-family: PingFang SC;
            font-size: 20px;
            font-weight: 500;
            line-height: 30px;
            display: flex;
            align-items: center;
            letter-spacing: normal;
            color: #001b51;
            &:nth-of-type(1) {
              width: 24px;
              height: 24px;
              border-radius: 3.43px;
              background: #1dc054;
              display: flex;
              justify-content: center;
              align-items: center;
              font-family: PingFang SC;
              font-size: 13.71px;
              font-weight: 500;
              line-height: 25px;
              letter-spacing: normal;
              color: #ffffff;
            }
            &:nth-of-type(2) {
              margin-right: 10px;
              margin-left: 16px;
              font-weight: bold;
            }
            &:nth-of-type(3) {
              width: 24px;
              height: 24px;
              border-radius: 3.43px;
              background: #f4333c;
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: border-box;
              margin-left: 10px;
              margin-right: 16px;
              font-family: PingFang SC;
              font-size: 13.71px;
              font-weight: 500;
              line-height: 20.57px;
              letter-spacing: normal;
              color: #ffffff;
            }
            &:nth-of-type(4) {
              font-family: PingFang SC;
              font-size: 20px;
              font-weight: bold;
              line-height: 25px;
              display: flex;
              align-items: center;
              letter-spacing: normal;
              color: #001b51;
            }
          }
        }
        .middle {
          width: 100%;
          color: rgba(0, 27, 81, 0.6);
          display: flex;
          .middleTop {
            display: flex;
            box-sizing: border-box;
            margin-left: 15px;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: 500;
            line-height: 24px;
            text-align: right;
            display: flex;
            letter-spacing: normal;
            color: rgba(0, 27, 81, 0.6);
            view {
              &:nth-of-type(1) {
                color: #f4333c;
                margin-left: 16px;
                margin-right: 8px;
                margin-bottom: 8px;
              }
            }
          }
        }
        .bottom {
          width: 375px;
          height: 40px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: linear-gradient(90deg, #e0edff 44%, rgba(224, 237, 255, 0) 100%);
          padding-left: 16px;
          padding-top: 8px;
          padding-bottom: 8px;
          .bottom-left {
            display: flex;
            align-items: center;
            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            display: flex;
            align-items: center;
            letter-spacing: normal;
            color: #001b51;
            img {
              width: 16px;
              height: 16px;
            }
            .carrier-text {
              max-width: 220px;
              display: inline-block;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              vertical-align: middle;
            }
          }
          .bottom-right {
            display: flex;
            view {
              line-height: 24px;
              &:nth-of-type(1) {
                color: white;
                background: #005dff;
                font-size: 14px;
                padding: 2px 10px;
                margin-right: 7px;
              }
              &:nth-of-type(2) {
                color: white;
                background: #1dc054;
                padding: 0 10px;
                padding: 2px 10px;
                font-size: 14px;
              }
            }
          }
        }
      }
      .logistics-item:hover {
        position: relative;
        z-index: 10;
        transition: all 0.2s ease-in-out;
        background: linear-gradient(180deg, #f1f6ff 0%, #ffffff 100%);
        box-sizing: border-box;
        border-width: 0px 0px 4px 0px;
        border-style: solid;
        border-color: #076aff;
        box-shadow: 0px 10px 16px 0px rgba(0, 27, 81, 0.2);
      }
    }
  }
  .logistics-top view {
    width: 120px;
    height: 2.4em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    line-height: 1.2em;
    vertical-align: middle;
    box-sizing: border-box;
  }
</style>
